import React from 'react';
import { formatRelativeTime } from '../../utils/helpers';

export interface FeedbackCardProps {
  type?: string;
  title?: string;
  by?: string;
  at?: string;
  preview?: string;
  /** Scene id or label when adventure-scoped (optional). */
  scene?: string;
  /** Deployment / public host (optional). */
  deployment?: string;
  /** Adventure display name or id line (optional). */
  adventureDisplay?: string;
  className?: string;
}

const FeedbackCard: React.FC<FeedbackCardProps> = ({
  type = 'Comment',
  title = '',
  by = 'Unknown',
  at = '',
  preview = '',
  scene = '',
  deployment = '',
  adventureDisplay = '',
  className = '',
}) => {
  const relTime = at ? formatRelativeTime(at) : '';
  const normalizedType = (type || 'Comment')
    .replace(/\s+/g, ' ')
    .replace(/^[^A-Za-z0-9]+/, '')
    .trim() || 'Comment';
  const contentPreview = (preview || '').trim();
  const sceneTrim = (scene || '').trim();
  const deploymentTrim = (deployment || '').trim();
  const adventureTrim = (adventureDisplay || '').trim();
  const hasContext = Boolean(sceneTrim || deploymentTrim || adventureTrim);

  return (
    <div className={`feedback-card ${className}`} role="article" aria-label={`Feedback: ${title || normalizedType}`}>
      <div className="feedback-card-header">
        <span className={`feedback-card-type feedback-card-type-${normalizedType.toLowerCase()}`}>{normalizedType}</span>
        {relTime && <span className="feedback-card-time">{relTime}</span>}
      </div>
      <div className="feedback-card-title">{title || '(No title)'}</div>
      {contentPreview ? <div className="feedback-card-preview">{contentPreview}</div> : null}
      {hasContext ? (
        <div className="feedback-card-context" role="region" aria-label="Where this feedback was reported">
          {sceneTrim ? (
            <div className="feedback-card-context-row">
              <span className="feedback-card-context-label">Scene</span>
              <span className="feedback-card-context-value">{sceneTrim}</span>
            </div>
          ) : null}
          {deploymentTrim ? (
            <div className="feedback-card-context-row">
              <span className="feedback-card-context-label">Deployment</span>
              <span className="feedback-card-context-value">{deploymentTrim}</span>
            </div>
          ) : null}
          {adventureTrim ? (
            <div className="feedback-card-context-row">
              <span className="feedback-card-context-label">Adventure</span>
              <span className="feedback-card-context-value">{adventureTrim}</span>
            </div>
          ) : null}
        </div>
      ) : null}
      <div className="feedback-card-meta">Logged by {by || 'Unknown'}</div>
    </div>
  );
};

export default FeedbackCard;
